export default {
  savingsTitle: {
    id: 'us_telco_comparators_landing_page_feature_savings_title',
    defaultMessage: 'Exclusive savings',
  },
  savingsDescription: {
    id: 'us_telco_comparators_landing_page_feature_savings_description',
    defaultMessage: "We've worked with our partners to help you save.",
  },
  flexibilityTitle: {
    id: 'us_telco_comparators_landing_page_feature_flexibility_title',
    defaultMessage: 'No-contract flexibility',
  },
  flexibilityDescription: {
    id: 'us_telco_comparators_landing_page_feature_flexibility_description',
    defaultMessage: 'Cancel or switch whenever you want.',
  },
  unlockedTitle: {
    id: 'us_telco_comparators_landing_page_feature_unlocked_title',
    defaultMessage: 'Built for unlocked phones',
  },
  unlockedDescription: {
    id: 'us_telco_comparators_landing_page_feature_unlocked_description',
    defaultMessage:
      'Fully compatible with any unlocked phone — on Back Market or not.',
  },
}
